const BASE_URL = "https://api.open-meteo.com/v1/forecast";

const WMO_ICON = {
  0: "day-sunny",
  1: "day-sunny",
  2: "day-cloudy",
  3: "cloudy",
  45: "fog",
  48: "fog",
  51: "sprinkle",
  53: "sprinkle",
  55: "sprinkle",
  56: "rain-mix",
  57: "rain-mix",
  61: "rain",
  63: "rain",
  65: "rain",
  66: "rain-mix",
  67: "rain-mix",
  71: "snow",
  73: "snow",
  75: "snow",
  77: "snow",
  80: "showers",
  81: "showers",
  82: "showers",
  85: "snow",
  86: "snow",
  95: "thunderstorm",
  96: "thunderstorm",
  99: "thunderstorm",
};

const WMO_SUMMARY = {
  0: "Ciel dégagé",
  1: "Principalement dégagé",
  2: "Partiellement nuageux",
  3: "Couvert",
  45: "Brouillard",
  48: "Brouillard givrant",
  51: "Bruine légère",
  53: "Bruine modérée",
  55: "Bruine dense",
  56: "Bruine verglaçante légère",
  57: "Bruine verglaçante dense",
  61: "Pluie légère",
  63: "Pluie modérée",
  65: "Pluie forte",
  66: "Pluie verglaçante légère",
  67: "Pluie verglaçante forte",
  71: "Neige légère",
  73: "Neige modérée",
  75: "Neige forte",
  77: "Grains de neige",
  80: "Averses légères",
  81: "Averses modérées",
  82: "Averses violentes",
  85: "Averses de neige légères",
  86: "Averses de neige fortes",
  95: "Orage",
  96: "Orage avec grêle",
  99: "Orage avec grêle forte",
};

export const weatherService = {
  get,
};

function get() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      resolve({ error: { message: "La géolocalisation n'est pas activée sur cet appareil" } });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const params = new URLSearchParams({
          latitude,
          longitude,
          current: "weather_code,wind_speed_10m,wind_gusts_10m",
          daily: "temperature_2m_max,temperature_2m_min,precipitation_probability_max",
          wind_speed_unit: "kmh",
          timezone: "auto",
          forecast_days: "1",
        });

        fetch(`${BASE_URL}?${params}`)
          .then((res) => res.json())
          .then(({ current, daily }) => {
            const code = current.weather_code;
            resolve({
              temperatureHigh: daily.temperature_2m_max[0],
              temperatureLow: daily.temperature_2m_min[0],
              windSpeed: current.wind_speed_10m,
              windGust: current.wind_gusts_10m,
              precipProbability: daily.precipitation_probability_max[0] / 100,
              icon: WMO_ICON[code] ?? "day-sunny",
              summary: WMO_SUMMARY[code] ?? "",
              error: null,
            });
          })
          .catch((error) => resolve({ error }));
      },
      (error) => resolve({ error }),
      { timeout: 10_000 },
    );
  });
}
